var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar-sandwich"},_vm._l((_vm.usersData),function(userData){return _c('div',{key:userData.identifier,staticClass:"avatar-container"},[_c('avatar',{attrs:{"user-data":userData,"size":40}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }